<template>
  <div>
    <v-simple-table fixed-header :height="height" class="log-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="min-width: 200px; max-width: 200px">Người thực hiện</th>
            <th style="min-width: 150px; max-width: 150px">Thời gian</th>
            <th>Mô tả</th>
          </tr>
        </thead>
        <tbody v-if="logs && logs.length > 0">
          <tr v-for="(log, index) in logs" :key="'log' + index">
            <td class="text-left">{{_.get(log, 'creatorFullName', '-')}}</td>
            <td class="text-left">{{formatDate(log.createdAt)}}</td>
            <td class="text-left">{{_.get(log, 'description', '-')}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "LogTable",
  props: {
    logs: {
      type: Array,
      required: true,
    },
    height: {
      type: [Number, String],
      default: 500,
    }
  },
  data() {
    return {

    }
  },
  methods: {
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style lang="scss">
.log-table {
  table {
    thead {
      tr {
        th {
          font-weight: bold;
        }
      }
    }
  }
}
</style>